var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sheet-page-width mx-auto", attrs: { id: "main" } },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.ajax.sendingCount > 0,
            expression: "ajax.sendingCount > 0"
          }
        ],
        attrs: { id: "ajax-throbber" }
      }),
      _vm._v(" "),
      _c(
        "header",
        {
          staticClass:
            "navbar navbar-dark bg-dark has-title flex-column flex-sm-row align-items-sm-center fixed-top",
          attrs: { id: "header" }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center align-self-start" },
            [
              _c("icon-button", {
                staticClass: "btn-inverse mr-2 btn-back",
                class: _vm.appState.backUrl ? "" : "back-hidden",
                attrs: { name: "arrow-back" },
                on: { click: _vm.goBack }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "navbar-brand" }, [
                _c("a", { attrs: { href: "/" } }, [
                  _vm._v(_vm._s(_vm.domainName)),
                  _c("span", { staticClass: "text-muted" }, [_vm._v(".net")])
                ]),
                _vm._v(" "),
                _c("small", [_vm._v(_vm._s(_vm.sheet.name))])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "nav justify-content-between ml-sm-auto" }, [
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.settingsTabSelected }
              },
              [
                _c("router-link", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "settings_title",
                      expression: "'settings_title'"
                    }
                  ],
                  staticClass: "nav-link text-truncate",
                  attrs: { to: "/settings" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.expensesTabSelected }
              },
              [
                _c("router-link", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "expenses_title",
                      expression: "'expenses_title'"
                    }
                  ],
                  staticClass: "nav-link text-truncate",
                  attrs: { to: "/expenses" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-item",
                class: { active: _vm.debtsTabSelected }
              },
              [
                _c("router-link", {
                  directives: [
                    {
                      name: "i18n",
                      rawName: "v-i18n",
                      value: "debts_title",
                      expression: "'debts_title'"
                    }
                  ],
                  staticClass: "nav-link text-truncate",
                  attrs: { to: "/debts" }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.changingState,
            expression: "changingState"
          }
        ],
        staticClass: "overlay"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-131cfa4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-131cfa4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/anonymous/app.vue
// module id = D+7J
// module chunks = 3